import React from 'react';
import {Edit, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import QuestionGroupFields from './QuestionGroupFields'
import ImageUploadWrapper from "../../components/ImageUploadWrapper";
import env from "../../env/env";

export const QuestionGroupEdit = props => (
    <Edit {...props}>
        <SimpleForm toolbar={<CustomToolbar/>}>
            <Grid container spacing={8}>
                <QuestionGroupFields/>
                <Grid item xs={12} sm={6}>
                    <ImageUploadWrapper {...props} url={'/api/questionGroups/photo/'} newBaseUrl={env.reportURL}/>
                </Grid>
            </Grid>
        </SimpleForm>
    </Edit>
);

export default QuestionGroupEdit
